import bem from 'utils/bem';

export const block = bem('text-box-options');
